import React from "react";
import "./Stylesheets/App.css";
// import Samurai from "./Components/Samurai";
// import Robotics from "./Components/Robotics";
// import Pirates from "./Components/Pirates";
// import Patriot from "./Components/Patriot";
// import Bjj from "./Components/Bjj";
// import Hulk from "./Components/Hulk";
// import Hologram from "./Components/Hologram";
// import SoundOn from "./Components/SoundOn";
// import Pokemon from "./Components/Pokemon";
// import Newspaper from "./Components/Newspaper";
// import Spiderman from "./Components/Spiderman";
// import Batman from "./Components/Batman";
// import Wolverine from "./Components/Wolverine";
// import Formula1 from "./Components/Formula1";
// import Thanksgiving from "./Components/Thanksgiving";
// import FreeHat from "./Components/FreeHat";
// import MapleGear from "./Components/MapleGear";
// import MapleBelt from "./Components/MapleBelt";
// import MapleClimb from "./Components/MapleClimb";
// import Mafia from "./Components/Mafia";
// import Thug from "./Components/Thug";
// import Bratva from "./Components/Bratva";
// import Cowboy from "./Components/Cowboy";
// import Yakuza from "./Components/Yakuza";
// import Hitman from "./Components/Hitman";
import Thug2 from "./Components/Thug2";

// mode: "animated" to screen-record, "static" to hold the final frame as a still
function App() {
  return <Thug2 mode="animated" />;
}
export default App;
